

import {
  Component,
  effect,
  OnInit,
  signal,
} from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { ConfirmationService, MessageService } from "primeng/api";

import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";

import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import {  take } from "rxjs";
import { Segnalazione_Firestore } from "src/app/models/firestore/segnalazioneFirestore.model";
import { SegnalazioniService } from "src/app/services/segnalazioni.service";
import { Segnalazione } from "src/app/models/segnalazione.model";
import { UtentiService } from "src/app/services/utenti.service";
import { UserService } from "src/app/services/user.service";
import { StatoSegnalazione } from "src/app/models/stato.segnalazione.model";
import { Utente } from "src/app/models/utente.model";


@Component({
    selector: "app-assegna-segnalazione",
    templateUrl: './assegna-segnalazione.component.html',
    styleUrls: ['../segnalazioni.component.css']
  })
  export class AssegnaSegnalazioneComponent implements OnInit {
    protected segnalazione:Segnalazione_Firestore;
    protected assegnaSegnalazioneForm: FormGroup;
    protected operatori:Utente[]=[];

    protected ref: DynamicDialogRef;
    isSaving = signal(false);;

    constructor(
        private logger: NGXLogger,
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public segnalazioniService:SegnalazioniService,
        public confirmationService:ConfirmationService,
        private messageService:MessageService,
        public dialogService: DialogService,
        private _formBuilder: FormBuilder,
        private userService: UserService,
        private utentiService: UtentiService,
      ) {

        effect(() => {
          const isSaving = this.isSaving();
          this.config.closable = !isSaving;
          this.config.closeOnEscape = !isSaving; //TODO: doesn't work;
        });
    }

    ngOnInit(): void {
        this.segnalazione = this.config.data.segnalazione;

        this.assegnaSegnalazioneForm = this._formBuilder.group({
          operatore:  new FormControl({value: null, disabled: true}, Validators.required),
        });
        this.loadOperatori();
    }

    loadOperatori(){
      this.utentiService.getOperatori()
      .pipe(take(1)).subscribe(operatoriFromDB =>{
          this.operatori = operatoriFromDB;
          this.assegnaSegnalazioneForm.get('operatore')?.enable();
      });
    }

    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        this.isSaving.set(true);
        this.assegnaSegnalazioneForm.disable();
        let segnalazioneDaModificare = new Segnalazione();
        let nuovoStatoSegnalazione = new StatoSegnalazione();
        nuovoStatoSegnalazione.id = 2;
            segnalazioneDaModificare.id     = this.segnalazione.id;
            segnalazioneDaModificare.autore = this.userService.getUser();
            segnalazioneDaModificare.operatoreInCarico = this.assegnaSegnalazioneForm.value.operatore;
            if(this.segnalazione.stato!=='PIANIFICATA' ){
              segnalazioneDaModificare.stato  = nuovoStatoSegnalazione;
            }
         this.segnalazioniService
          .modifica(segnalazioneDaModificare)
          .pipe(take(1))
          .subscribe({
            error: (e) => {
              this.isSaving.set(false);
              this.assegnaSegnalazioneForm.enable();
              this.messageService.add({
                severity: "info",
              summary: "Errore" , life:10000,
                detail: "Errore in fase di asegnazione della segnalazione",
              });
              this.dialogRef.close({
                success: false
              });
            },
            complete: () => {
              this.isSaving.set(false);
              this.assegnaSegnalazioneForm.enable();
              this.dialogRef.close({
                success: true
              });
            },
        });
      }
    }
  }
